import {
  borderRadius,
  SkeletonLoaderArea,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 414px;
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
`;

export const TitleLabel = styled.span`
  ${typographyV2.titleBase};
`;

export const StyledButtonGroup = styled.div`
  [data-button-group] {
    ${borderRadius.r2};
    width: 175px;
  }
  [data-button-group-item] {
    padding: 4px 8px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ChartTitleLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const styledLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '300px',
      borderRadius: '8px',
    },
  },
];

export const ChartWrapper = styled.div`
  opacity: 1;
  transition: opacity 800ms ease-in-out;
  min-height: 300px;
`;
